import { useQuery } from "@apollo/client";
import GET_ME from "queries/getMe";
import { useCallback, useMemo } from "react";
export const initialContext = {
    firstName: "",
    isAdmin: false,
    isEditor: false,
    isSocials: false,
    onClearToken: () => undefined,
    onGetToken: () => undefined,
    onSetToken: () => undefined
};
const useUserContext = () => {
    const { data } = useQuery(GET_ME, {
        fetchPolicy: "cache-first"
    });
    const onClearToken = useCallback(() => {
        localStorage.removeItem("token");
    }, []);
    const onSetToken = useCallback((newToken) => {
        localStorage.setItem("token", newToken);
    }, []);
    const onGetToken = useCallback(() => localStorage.getItem("token"), []);
    const user = useMemo(() => ({
        firstName: data?.me?.firstName ?? "",
        isAdmin: data?.me?.isAdmin ?? false,
        isEditor: data?.me?.isEditor ?? false,
        isSocials: data?.me?.isSocials ?? false,
        onClearToken,
        onGetToken,
        onSetToken,
        username: data?.me?.username
    }), [
        data?.me?.firstName,
        data?.me?.isAdmin,
        data?.me?.isEditor,
        data?.me?.isSocials,
        data?.me?.username,
        onClearToken,
        onGetToken,
        onSetToken
    ]);
    return user;
};
export default useUserContext;
